import {
  nFormatter,
  createSeries,
  createSQL,
  seriesHead,
  appendAggregateValues,
  seriesDataItem,
  getSeriesColors,
  extractColors,
  createFilter
} from "@/components/charts/common";

import pluralize from 'pluralize';
import apexChartOptions from "@/common/apex-chart-defaults";

function resolve(path, obj) {
  return path.split('.').reduce(function(prev, curr) {
    return prev ? prev[curr] : null
  }, obj || self)
}

function getItemText(parameters, key, value) {
  let node = resolve(key, parameters);
  if(!node) {
    return null;
  }
  for(let i = 0; i < node.items.length; i++) {
    const item = node.items[i];
    if(item[node.itemValue] == value) {
      if(typeof item.description != "undefined") {
        return item.description;
      } else {
        return item[node.itemText];
      }
    }
  }
  return null;
}

export async function hydrator(parameters, data, chart) {
  //  data.valid = false;
  //  data.width = 500;
  //  data.height = 500;
  //  data.type = 'line';

  // console.log("bar chart hydrator");

  let options = {};

  options.chart = {...apexChartOptions};
  options.chart.id = chart.id;
  options.dataLabels = {
    enabled: true
  };
  options.plotOptions = {};
  options.title = {text: undefined};
  options.subtitle = {text: undefined};
  options.subTitle = {};

  options.colors = ['#C1BEC7', '#FF0814', '#151821', '#857A89', '#F54355'];
  // options.colors = ['#FA8F13', '#EE2C1F', '#6A7785', '#283BD1', '#454E5D'];
  options.colors = ['#003f5c', '#58508d', '#bc5090', '#ff6361', '#ffa600'];
  // console.log("parameters.colorGradient", parameters.colorGradient);
  if (typeof parameters.colorGradient.item.id != "undefined" && parameters.colorGradient.item.id) {
    // options.colors = parameters.colorGradient.item.color.split(":");
  }
  options.yaxis = {
    labels: {
      show: true,
      offsetX: 0,
      offsetY: 0,
      formatter: function(value) {
        if (isNaN(value)) {
          return value;
        }
        return nFormatter(value, 2);
      }
    }
  };

  options.xaxis = {
    labels: {
      show: true,
      offsetX: 0,
      offsetY: 0
    },
    axisBorder: {
      show: true,
      color: '#78909C',
      height: 1,
      width: '100%',
      offsetX: 0,
      offsetY: 0
    },
    axisTicks: {
      show: true,
      borderType: 'solid',
      color: '#78909C',
      height: 6,
      offsetX: 0,
      offsetY: 0
    }
  };

  options.legend = {
    show: resolve("showLegendSource.value", parameters),
    position: resolve("legendPositionData.value", parameters)
  };

  const gridHeight = chart.grid.h;
  const layoutHeight = chart.grid.layout.rowHeight;
  const realHeight = (layoutHeight * gridHeight);
  data.height = realHeight;

  // console.log("layoutHeight", layoutHeight);
  // console.log("gridHeight", gridHeight);
  // console.log("realHeight", realHeight);
  // console.log("grid", chart.grid);
  /***
    options.legend = {};
    options.legend.show = false;

    options.xaxis = {};
    options.xaxis.labels = {};
    options.xaxis.labels.show = false;

    options.yaxis = {};
    options.yaxis.labels = {};
    options.yaxis.labels.show = false;

  **/

  // data.options = {...options};

  let chartDataSource = parameters.chartDataSource;

  let items = parameters.chartDataSource.items;




  for (let i = 0; i < items.length; i++) {
    await items[i].update(true);
    // console.log("chartDataSource", items[i]);
  }

  if (!chartDataSource.item.data.length && items.length) {
    chartDataSource.item = items[0];
    chartDataSource.value = items[0].id;
  }
  // console.log("chartDataSource.item.headers", chartDataSource.item.headers);
  chartDataSource.item.headers.forEach(function(t) {
    // console.log(t.text + " : " + t.type.type + " : " + t.type.points);
  });

  //  console.log("chartDataSource.item.fullQuery", chartDataSource.item.fullQuery);


  let query = {};
  let fullQuery = chartDataSource.item.fullQuery;
  query.id = chartDataSource.item.id;
  // "strftime('%Y %m', `date`)"

  let _group = resolve("groupData.value", parameters);
  let _item = resolve("itemData.value", parameters);
  let _transformItem = resolve("transformItemData.value", parameters);
  let _value = resolve("valueData.value", parameters);
  let _transformValue = resolve("transformValueData.value", parameters);
  let _titleValue = resolve("content.value", parameters);

  options.title.text = resolve("title.value", parameters);
  options.subtitle.text = resolve("subtitle.value", parameters);

  data.decrement = 0;
  if(options.title.text) {
    data.decrement = data.decrement+10;
  }
  if(options.subtitle.text) {
    data.decrement = data.decrement+10;
  }

  _group = _group ? _group : null;
  _item = _item ? _item : _group;

  _group = _group ? _group : null;
  _item = _item ? _item : null;

  const itemTransformText = getItemText(parameters, "transformItemData", _transformItem);
  const valueText = getItemText(parameters, "valueData", _value);
  // const groupText = getItemText(parameters, "groupData", _group);

  if(itemTransformText && _titleValue == "<h2>Title</h2>") {
    // parameters.content.value = "<h2>" + itemTransformText + " " + pluralize.plural(valueText) + " By " + groupText + "</h2>";
  }


  if(_value) {
    _value = _transformValue.replace("field", _value);
  }



  // console.log("parameters", parameters);
  //console.log("_item", _item);
  //console.log("_value", _value)

  let _filters = resolve("tree.filters", chart);
  // console.log(_filters);
  let filters = _filters ? Object.values(_filters) : [];

  let customFilter = resolve("customFilter.value", parameters);

  query.sql = createSQL(fullQuery, _group, _item, _value, filters, _transformValue, customFilter);
  // console.log("query", query);
  let dd = await chartDataSource.item.request(query);
  chart.response = dd;



  if(dd.data.length > 1000) {
    return false;
  }


  // console.log('chartDataSource.item', chartDataSource.item);
  // data = {...data,  ...{series: createSeries(chartDataSource.item.data)}};
  // console.log("chart response", dd.data);
  dd.data = dd.data.filter(row => row.x != null);
  dd.data = dd.data.sort(function(a, b) { return b.y - a.y});
  let series = dd.data.map(item => item.y ? item.y : 0);
  let labels = dd.data.map(item => item.x);
  let extractedColors = extractColors(resolve("colors.value", parameters));
  options.colors = getSeriesColors(extractedColors, labels);
  console.log("options.colors pie", options.colors);
  console.log(extractedColors);

  // console.log("pie chart series", series);
  options.series = series;
  options.labels = labels;

  data.series = series;

  // console.log('series');
  // console.log(series);

  options.animations = {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
            enabled: true,
            delay: 150
        },
        dynamicAnimation: {
            enabled: true,
            speed: 350
        }
    };


  if (series.length) {

    data.options = options;



    // console.log("data.options", data.options);
    data.valid = true;
    if (typeof chart.instance != 'undefined' && chart.instance) {
      // console.log('chart.instance', 'exist');
      //
      // chart.instance.updateSeries(series, false, true);
      chart.instance.updateOptions(options, true, true);
      //console.log('series', series);
      // chart.instance.refresh();
      // console.log('chart.instance', chart.instance);
    } else {
      //  console.log('chart.instance', 'not set');
    }
  }



}
